import { useEffect } from "react";
import AlertPage from "./AlertPage";
import { useNavigate } from "react-router-dom";

export default function Home({ alertEmail, alertMsg }) {
  const navigate = useNavigate();

  // Store the URL in localStorage
  const currentUrl = window.location.href;
  localStorage.setItem("storedUrl", currentUrl);
  // Redirect to auth0 login page
  useEffect(() => {
    if (!alertEmail ) {
      const originPath = currentUrl.split("/")[3];
      if (originPath.toLowerCase() === "register") {
        // Redirect to register page
        navigate("/register", { replace: true });
      } else {
        // Redirect to register page
        navigate("/login", { replace: true });
      }
    }
  }, [alertEmail, currentUrl]);

  if (alertEmail) {
    return <AlertPage alertEmail={alertEmail} alertMsg={alertMsg} />;
  }
}
